import React, { useState, useEffect } from "react";

/** Components */
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper, TablePagination, Checkbox, TableFooter, ButtonGroup } from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import SelectStatusButton from "../../commons/SelectStatusButton";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import RefreshIcon from "@mui/icons-material/Refresh";

/** Api & Function */
import { getBact, postSync, updateBactStatus } from "../../../services/api";
import { convertQueryStringToObject } from "../../../services/libService";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import { useTranslation } from "react-i18next";

/** Hook */
import { useParamFilter } from "../../commons/customHook";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

const Bact = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const paramFilter = useParamFilter({ page: 1, per_page: 50 }, getBact),
    { fetchData, loading } = paramFilter;
  //filter
  const filter = convertQueryStringToObject(location.search);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN TÀI KHOẢN NGÂN HÀNG"));
    fetchData(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
        <ButtonGroup style={{ height: 40, marginRight: 10 }}>
          {/* <Button onClick={() => setSearchOpen(prev => !prev)} variant="outlined">
                        <SearchIcon />
                    </Button> */}
          <ButtonWithAPICallComponent title="Lấy dữ liệu từ ERP" api={() => postSync({ object: "bacts" })}>
            <RefreshIcon />
          </ButtonWithAPICallComponent>
        </ButtonGroup>
      </div>
      {/* <Collapse in={isSearchOpen}>
                <TextField
                    label={t('Lệnh điều động số')}
                    value={input.bill_order || ''}
                    onChange={e => setInput(prev => ({ ...prev, bill_order: e.target.value }))}
                    style={{ margin: '5px' }}
                    InputProps={{ style: { minWidth: '200px' } }}
                />
                <TextField
                    label={t('Số xe')}
                    value={input.vehicle || ''}
                    onChange={e => setInput(prev => ({ ...prev, vehicle: e.target.value }))}
                    style={{ margin: '5px' }}
                    InputProps={{ style: { minWidth: '200px' } }}
                />

                <TextField
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    label={t('Từ ngày')}
                    value={input.start_date || ''}
                    onChange={e => setInput(prev => ({ ...prev, start_date: e.target.value || null }))}
                    style={{ margin: '5px' }}
                    InputProps={{ style: { minWidth: '200px' } }}
                />
                <TextField
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    label={t('Đến ngày')}
                    value={input.end_date || ''}
                    onChange={e => setInput(prev => ({ ...prev, end_date: e.target.value || null }))}
                    style={{ margin: '5px' }}
                    InputProps={{ style: { minWidth: '200px' } }}
                />
                <Button variant='outlined' onClick={handleSearch} style={{ margin: '10px 0' }}>{t('Tìm kiếm')}</Button>
            </Collapse> */}
      {loading ? <LoadingProgress /> : <BactTable {...paramFilter} />}
    </div>
  );
};

export default Bact;

const BactTable = ({ page, perPage, setPage, setPerPage, isAllow, total, setData, data }) => {
  const [changeIds, setChangeIds] = useState([]); //ids cua nhung bank can cap nhat
  const { t } = useTranslation();
  const handleCheckBoxClick = (e, id) => {
    e.stopPropagation();
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateBactStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };

  return (
    <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
            <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tên người thụ hưởng")}</TableCell>
            <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Số tài khoản")}</TableCell>
            <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Swiftcode")}</TableCell>
            <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Tên hiển thị ngân hàng")}</TableCell>
            <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Loại tiền")}</TableCell>
            <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>

            <TableCell style={{ border: "0.5px solid lightgray" }}>
              <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length ? (
            data.map((row, index) => (
              <TableRow
                key={row.id}
                // onClick={(e) => handleRowClick(e, row, index)}
                // hover
                // style={{ cursor: 'pointer' }}
              >
                <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                  {row.act_holder}
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", whiteSpace: "nowrap" }} align="left">
                  {row.act_number}
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                  {row.swift_code}
                </TableCell>
                <TableCell style={{ border: "0.5px solid lightgray", align: "left" }}>{row.bank_code}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{row.currency}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>
                  <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={(e) => handleCheckBoxClick(e, row.id)} />
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={50}>{t(isAllow ? "Không có dữ liệu" : "No permission")}</TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};
